import { ICalendarPrintDialogModel } from "@/Appointments/Models/UI/ICalendarPrintDialogModel";
import { ButtonControl } from "@/Common/Components/Buttons/ButtonControl";
import ButtonGroup from "@/Common/Components/Buttons/ButtonGroup";
import { RadioButton } from "@/Common/Components/Inputs/RadioButton";
import { Popup } from "@/Common/Components/Modals/Popup";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IPrintCalendarDialogProps {
    Model: ICalendarPrintDialogModel
}

class PrintCalendarDialog extends React.Component<IPrintCalendarDialogProps, never> {
    public render(): JSX.Element {
        return (
            <Popup draggable={true} cssClass="print" title={cacheStore.GetString("PrintAppointmentTitleLabel")} closeTarget={LocalOperations.Calendar.Calendar_PrintDialog_Cancel_Click}>
                <div className="p-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <RadioButton
                                items={Immutable.List([
                                    new KeyValuePair(cacheStore.GetString("DateLabel"), "Date"),
                                    new KeyValuePair(cacheStore.GetString("IdentifierDLabel"), "Identifier"),
                                    new KeyValuePair(cacheStore.GetString("PatientLabel"), "Patient"),
                                    new KeyValuePair(cacheStore.GetString("LabelLabel") + " C1", "Labels")
                                ])/* Immutable.List([]) ; this.state.calendar.get("ClinicianPrintOptions") */}
                                radioInputGroupId="ClinicianPrintOptions"
                                onePerLine={false}
                                changeOperation={LocalOperations.Calendar.Calendar_PrintDialog_ClinicianPrintOptionChange}
                                selectedItem={this.props.Model.get("SelectedPrintOption")}
                            />
                        </div>
                    </div>
                </div>
                <div className="p-footer flex-display flex-end">
                    <ButtonGroup>
                        <ButtonControl
                            variant="neutral"
                            onClick={this.OnCancelClick.bind(this)}
                            label={cacheStore.GetString("CancelLabel")}
                        />
                        <ButtonControl
                            variant="brand"
                            onClick={this.OnPrintClick.bind(this)}
                            label={cacheStore.GetString("PrintLabel")}
                        />
                    </ButtonGroup>
                </div>
            </Popup>
        );
    }

    public OnCancelClick(): void {
        var operation = new LocalEvent(LocalOperations.Calendar.Calendar_PrintDialog_Cancel_Click);
        LocalEventDispatcher.dispatch(operation);
    }

    public OnPrintClick(): void {
        var operation = new LocalEvent(LocalOperations.Calendar.Calendar_PrintDialog_Print_Click);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { PrintCalendarDialog };
